export default "__VITE_ASSET__B$KEU2zU__"